import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit'
import {
  getActionOwnersList,
  getRiskMitigationAdvanceControlTableData,
  updateRiskMitigationAdvanceControlTableData,
} from './risk-mitigation.async'

const initialState = {
  riskMitigationAdvanceControlLoader: false,
  riskMitigationAdvanceControlTableData: {},
  riskMitigationActionOwnersLoader: false,
  riskMitigationActionOwnersList: [],
}

const RiskMitigationReducer = createSlice({
  name: 'RiskMitigationReducer',
  initialState,
  reducers: {
    emptyRiskMitigationReducer: (state) => {},
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getRiskMitigationAdvanceControlTableData.pending), (state) => {
      state.riskMitigationAdvanceControlLoader = true
    })
    builder.addMatcher(
      isAnyOf(getRiskMitigationAdvanceControlTableData.fulfilled),
      (state, action) => {
        state.riskMitigationAdvanceControlLoader = false
        state.riskMitigationAdvanceControlTableData = action.payload.data
      },
    )
    builder.addMatcher(isAnyOf(getRiskMitigationAdvanceControlTableData.rejected), (state) => {
      state.riskMitigationAdvanceControlLoader = false
    })
    builder.addMatcher(isAnyOf(updateRiskMitigationAdvanceControlTableData.pending), (state) => {
      state.riskMitigationAdvanceControlLoader = true
    })
    builder.addMatcher(
      isAnyOf(updateRiskMitigationAdvanceControlTableData.fulfilled),
      (state, action) => {
        state.riskMitigationAdvanceControlLoader = false
        state.riskMitigationAdvanceControlTableData = action.payload.data
      },
    )
    builder.addMatcher(isAnyOf(updateRiskMitigationAdvanceControlTableData.rejected), (state) => {
      state.riskMitigationAdvanceControlLoader = false
    })
    builder.addMatcher(isAnyOf(getActionOwnersList.pending), (state) => {
      state.riskMitigationActionOwnersLoader = true
    })
    builder.addMatcher(isAnyOf(getActionOwnersList.fulfilled), (state, action) => {
      state.riskMitigationActionOwnersLoader = false
      state.riskMitigationActionOwnersList = action.payload.data
    })
    builder.addMatcher(isAnyOf(getActionOwnersList.rejected), (state) => {
      state.riskMitigationActionOwnersLoader = false
    })
  },
})

export const { emptyRiskMitigationReducer } = RiskMitigationReducer.actions
export default RiskMitigationReducer.reducer
